export interface AnswerFeedback {
  correct: boolean;
  message: string;
  hintLevel: number;
}

export function seededShuffle<T>(items: readonly T[], seed: number): T[] {
  const result = [...items];
  let state = Math.abs(seed) || 1;
  for (let index = result.length - 1; index > 0; index -= 1) {
    state = (state * 1664525 + 1013904223) >>> 0;
    const swapIndex = state % (index + 1);
    [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
  }
  return result;
}

export function uniqueChoices<T>(correct: T, distractors: readonly T[], count: number): T[] {
  return [correct, ...distractors].filter((item, index, items) => items.indexOf(item) === index).slice(0, count);
}

export function evaluateChoice(
  choice: string,
  correct: string,
  previousWrongAttempts: number,
): AnswerFeedback {
  if (choice === correct) {
    return { correct: true, message: 'Bagus! Jawabanmu benar.', hintLevel: previousWrongAttempts };
  }

  const hintLevel = Math.min(2, previousWrongAttempts + 1);
  return {
    correct: false,
    message: hintLevel >= 2
      ? `Hampir! Dengarkan bunyinya, lalu cari ${correct}.`
      : 'Hampir! Coba lagi, yuk.',
    hintLevel,
  };
}
